const Comment = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <path
        stroke='#000'
        strokeWidth='1.5'
        d='M18.913 20.892a.351.351 0 01-.044.231c-.077.128-.213.161-.32.09l-2.676-1.782-.351.12c-1.072.369-2.254.56-3.522.56-5.513 0-9.25-3.68-9.25-8.68S6.487 2.75 12 2.75s9.25 3.68 9.25 8.68c0 2.416-.895 4.6-2.515 6.173l-.276.268.454 3.021z'
      />
      <circle
        cx='12'
        cy='12'
        r='1'
        fillRule='nonzero'
        transform='matrix(-1 0 0 1 24 0)'
      />
      <circle
        cx='16'
        cy='12'
        r='1'
        fillRule='nonzero'
        transform='matrix(-1 0 0 1 32 0)'
      />
      <circle
        cx='8'
        cy='12'
        r='1'
        fillRule='nonzero'
        transform='matrix(-1 0 0 1 16 0)'
      />
      <path
        fill='#000'
        d='M19.655 20.781a1.1 1.1 0 01-.143.728.97.97 0 01-1.379.328l-2.367-1.576c-1.13.388-2.39.6-3.766.6-6.136 0-10-4.222-10-9.43C2 6.221 5.864 2 12 2s10 4.222 10 9.43c0 2.626-.982 5.001-2.742 6.711l.397 2.64zm-3.684-2.253l2.03 1.35-.35-2.326.59-.574c1.457-1.415 2.259-3.37 2.259-5.548 0-4.518-3.382-7.849-8.5-7.849s-8.5 3.33-8.5 7.85c0 4.518 3.382 7.849 8.5 7.849 1.194 0 2.302-.179 3.3-.522l.67-.23zM12 13a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 0a1 1 0 110-2 1 1 0 010 2z'
      />
    </g>
  </svg>
);

export default Comment;
